/* su-pdp-lightbox.js — StyleUp.Today (Spirit Animal PDP)
   Two fixes for the product image lightbox, both fully DYNAMIC (keyed on the
   colour name found in each image's ALT text, never on image position — so it
   works for any product regardless of which colours/positions it has):

   (1) Colour-filter the lightbox modal: show only the selected colour's photos
       plus colour-agnostic photos (lifestyle/model shots whose alt has no
       colour). Mirrors the main-gallery filter (su-variant-media-filter.js),
       which doesn't reach the separate modal DOM — that's why off-white was
       bleeding into the lightbox.
   (2) Make clicking ANY gallery image open the lightbox. In this theme the
       Dawn zoom button (.product__media-toggle) renders 0x0 and doesn't overlay
       the image, so image clicks didn't reliably open the modal (lifestyle
       shots especially). We delegate the click to that media's opener button.

   Scoped to pages flagged .su-pdp (Capybara now; broaden at rollout). */
(function () {
  if (!document.querySelector('.su-pdp')) return;

  function colorFieldset() {
    var fss = document.querySelectorAll('variant-selects fieldset, .product-form fieldset, fieldset');
    for (var i = 0; i < fss.length; i++) {
      var lg = fss[i].querySelector('legend, label');
      if (lg && /colou?r/i.test(lg.textContent || '')) return fss[i];
    }
    return null;
  }
  function colorList(fs) {
    var s = []; if (!fs) return s;
    fs.querySelectorAll('input[type="radio"], option, label[data-su-color]').forEach(function (el) {
      var v = (el.getAttribute && el.getAttribute('data-su-color')) || el.value || '';
      v = (v || '').trim();
      if (v && s.indexOf(v) === -1) s.push(v);
    });
    return s;
  }
  function selectedColor(fs) {
    if (!fs) return null;
    var c = fs.querySelector('input[type="radio"]:checked');
    if (c) return (c.value || '').trim();
    var sel = fs.querySelector('select');
    if (sel) return (sel.value || '').trim();
    return null;
  }
  function colorOfAlt(alt, colors) {
    var found = null, a = (alt || '').toLowerCase();
    for (var i = 0; i < colors.length; i++) {
      var c = colors[i].toLowerCase();
      if (c && a.indexOf(c) !== -1) { if (!found || c.length > found.length) found = c; }
    }
    return found;
  }
  function setDisp(el, val) {
    // only write when changing -> avoids feedback loops with the MutationObserver
    if (el.style.getPropertyValue('display') !== val) el.style.setProperty('display', val, 'important');
  }
  function filterModal() {
    var content = document.querySelector('.product-media-modal__content');
    if (!content) return;
    var fs = colorFieldset();
    var colors = colorList(fs);
    var sel = (selectedColor(fs) || '').toLowerCase();
    if (!colors.length || !sel) return;
    // We must FORCE the modal's display because su-extras.js (variant-media-id
    // filter) both (a) wrongly shows off-white for White via substring matching
    // and (b) hides colour-agnostic lifestyle shots. Decide purely from ALT text
    // (longest colour match wins, so "off white" != "white"):
    //   show  = colour-agnostic (lifestyle/back) OR matches the selected colour
    //   hide  = any other named colour
    // Fully dynamic — independent of how many colours/positions a product has.
    Array.prototype.forEach.call(content.querySelectorAll('img'), function (img) {
      var target = (img.parentElement && img.parentElement !== content) ? img.parentElement : img;
      var alt = img.getAttribute('alt') || '';
      var c = colorOfAlt(alt, colors);
      // lifestyle/model shots ("...worn in...") are vibe photos — show for every
      // colour even if the alt names the colour the model happens to wear.
      var sc = /sizechart/i.test((img.getAttribute('src')||'')+' '+(img.currentSrc||'')+' '+(img.src||''));
      var show = !sc && (/\bworn\b/i.test(alt) || (c === null) || (c === sel));
      setDisp(target, show ? 'block' : 'none');
    });
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(filterModal, 80); }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, .product-form, fieldset')) schedule();
  }, true);

  var modal = document.querySelector('product-modal');
  if (modal && window.MutationObserver) {
    new MutationObserver(schedule).observe(modal, {
      attributes: true, attributeFilter: ['open', 'class', 'style'], childList: true, subtree: true
    });
  }

  // After the modal opens, the single observer-driven filter run can fire before
  // Dawn finishes populating/moving the modal media (and with duplicate
  // product-modal nodes from section re-renders the observer may watch the wrong
  // one) — that let the Off White flat leak into a White selection. Re-apply the
  // filter on a few timed retries after any open. Idempotent (setDisp only writes
  // on change), so no flicker.
  function scheduleOpen() { [80, 250, 500, 900, 1400].forEach(function (d) { setTimeout(filterModal, d); }); }
  // clicking any gallery image opens the lightbox (the 0x0 toggle won't catch it)
  document.addEventListener('click', function (e) {
    if (e.target.closest('.product__media-toggle')) { scheduleOpen(); return; } // native button already handled
    var opener = e.target.closest('.product__media-list .product__modal-opener');
    if (!opener) return;
    var btn = opener.querySelector('.product__media-toggle');
    if (btn) { e.preventDefault(); btn.click(); scheduleOpen(); }
  });

  if (document.readyState !== 'loading') filterModal();
  else document.addEventListener('DOMContentLoaded', filterModal);
})();
